module.exports = __webpack_public_path__ + "img/icon_search_helmet_offline.d6bac529.png";